/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Otaupdatebtnlater3Inputs */



/**
* | output |
* | --- |
* | "Later" |
*
* @param {Otaupdatebtnlater3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const otaupdatebtnlater3 = /** @type {((inputs?: Otaupdatebtnlater3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otaupdatebtnlater3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Later")
	if (locale === "es") return /** @type {LocalizedString} */ ("Más tarde")
	return /** @type {LocalizedString} */ ("Позже")
});
export { otaupdatebtnlater3 as "otaUpdateBtnLater" }